$(document).ready(function () {

  function setTabActive() {

    $('#explore-tabs > li').each(function () {

      if ($(this).attr('data-is-selected') === "true") {
        $($(this).children('span').css('color','black'));
        $($(this).children('div').css('background','#005D95'));

        const tab = $(this).attr('data-target');

        $('.jc-tabs-content > div').each(function () {

          if (tab === $(this).children('div').attr('id')) {
            $(this).children('div').removeClass('d-none');
            $(this).children('div').addClass('d-block');

            if((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&  $(this).children('div').children('div').children('div').children().length > 6) || ($(this).children('div').children('div').children('div').children().length > 12)) {
              $(this).children('button').removeClass('d-none');

              $(this).children('button').on('click', function () {
                $(this).parent().children('div').css('max-height', 'unset');
                $(this).remove();
              });

            }

          } else {
            $(this).children('div').removeClass('d-block');
            $(this).children('div').addClass('d-none');
            $(this).children('button').addClass('d-none');
          }

        });

      } else {
        $($(this).children('span').css('color','#A0AEC0'));
        $($(this).children('div').css('background','#A0AEC0'));
      }

    });

  }

  setTabActive();

  $('#marcas-tab, #carrocerias-tab, #estilosdevida-tab').on('click', function (e) {

    const target = $(this).attr('id');

    $(this).attr('data-is-selected', 'true');

    $('#explore-tabs > li').each(function () {

      if (target !== $(this).attr('id')){
        $(this).attr('data-is-selected', 'false');
      }

    });

    setTabActive();

  });

});
